const locales = [
  { code: 'en', label: 'EN' },
  { code: 'el', label: 'ΕΛ' },
] // todo: temporarily placed here, fetch from backend or at least store at config/env file

export const state = {
  locales: locales,
}

export const getters = {
  locales: (state) => state.locales,
  fullLocale: (state) => (code) =>
    state.locales.find((locale) => locale.code === code),
}

export const mutations = {}

export const actions = {}
